import { Text, TextProps, Title } from "@dropbox/dig-components/typography";
import { Box, BoxProps } from "@dropbox/dig-foundations";
import i18n from "@mirage/translations";

import type {
  EmployeeType,
  UserInfo,
} from "@mirage/mosaics/UserProfilePage/types";

export const UserProfileName = ({
  user,
  boxProps,
}: {
  user: Pick<UserInfo, "name">;
  boxProps?: BoxProps<"style">;
}) => {
  return (
    <Box
      as={Title}
      size="large"
      weightVariant="emphasized"
      tagName="span"
      marginTop="16"
      marginBottom="8"
      {...boxProps}
    >
      {user.name}
    </Box>
  );
};

export const UserProfileRole = ({
  user,
  textSize = "medium",
}: {
  user: Pick<UserInfo, "role"> & {
    type?: EmployeeType;
    level?: string | null;
    team_names?: string[];
  };
  textSize?: TextProps["size"];
}) => {
  return (
    <>
      <Text size={textSize} color="faint" variant="paragraph">
        {user.role}
        {user.type === "Regular" && user.level && ` (${user.level})`}
      </Text>
      {user.type && user.type === "Contractor" && (
        <Text size={textSize} color="faint">
          {" "}
          ({i18n.t("user_profile_contractor_label")})
        </Text>
      )}
      {!!user.team_names?.length && (
        <>
          <Text
            size={textSize}
            color="faint"
            style={{
              marginLeft: "4px",
              marginRight: "4px",
              display: "inline-block",
            }}
          >
            {i18n.t("user_profile_subtitle_static_on")}
          </Text>
          {user.team_names.map((teamName, index) => (
            <Text
              key={`user-profile-page-team__${teamName}`}
              size={textSize}
              color="faint"
              variant="paragraph"
            >
              {index > 0 && <strong>{", "}</strong>}
              <Text size={textSize} color="faint" isBold>
                {teamName}
              </Text>
            </Text>
          ))}
        </>
      )}
    </>
  );
};
